module.exports = __webpack_public_path__ + "static/media/Upload Car Image@3x.cd6959e7.png";